/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AddWordReq } from '../models/add-word-req';
import { AddWordResp } from '../models/add-word-resp';
import { DeleteWordReq } from '../models/delete-word-req';
import { DeleteWordResp } from '../models/delete-word-resp';
import { GetKeyReq } from '../models/get-key-req';
import { GetKeyResp } from '../models/get-key-resp';
import { GetRefNumbeResp } from '../models/get-ref-numbe-resp';
import { GetWordsReq } from '../models/get-words-req';
import { GetWordsResp } from '../models/get-words-resp';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentConfigService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getKey
   */
  static readonly GetKeyPath = '/env';

  /**
   * Get config
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getKey()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getKey$Response(params: {
    body: GetKeyReq
  }): Observable<StrictHttpResponse<GetKeyResp>> {

    const rb = new RequestBuilder(this.rootUrl, EnvironmentConfigService.GetKeyPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GetKeyResp>;
      })
    );
  }

  /**
   * Get config
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getKey$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getKey(params: {
    body: GetKeyReq
  }): Observable<GetKeyResp> {

    return this.getKey$Response(params).pipe(
      map((r: StrictHttpResponse<GetKeyResp>) => r.body as GetKeyResp)
    );
  }

  /**
   * Path part for operation getRefNumber
   */
  static readonly GetRefNumberPath = '/env/next-reference-number';

  /**
   * Get config
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRefNumber()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRefNumber$Response(params?: {
  }): Observable<StrictHttpResponse<GetRefNumbeResp>> {

    const rb = new RequestBuilder(this.rootUrl, EnvironmentConfigService.GetRefNumberPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GetRefNumbeResp>;
      })
    );
  }

  /**
   * Get config
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getRefNumber$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRefNumber(params?: {
  }): Observable<GetRefNumbeResp> {

    return this.getRefNumber$Response(params).pipe(
      map((r: StrictHttpResponse<GetRefNumbeResp>) => r.body as GetRefNumbeResp)
    );
  }

  /**
   * Path part for operation addWord
   */
  static readonly AddWordPath = '/env/add-word';

  /**
   * Get word dictionary
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addWord()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addWord$Response(params: {
    body: AddWordReq
  }): Observable<StrictHttpResponse<AddWordResp>> {

    const rb = new RequestBuilder(this.rootUrl, EnvironmentConfigService.AddWordPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AddWordResp>;
      })
    );
  }

  /**
   * Get word dictionary
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `addWord$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addWord(params: {
    body: AddWordReq
  }): Observable<AddWordResp> {

    return this.addWord$Response(params).pipe(
      map((r: StrictHttpResponse<AddWordResp>) => r.body as AddWordResp)
    );
  }

  /**
   * Path part for operation deleteWord
   */
  static readonly DeleteWordPath = '/env/delete-word';

  /**
   * Delete word in dictionary
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteWord()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteWord$Response(params: {
    body: DeleteWordReq
  }): Observable<StrictHttpResponse<DeleteWordResp>> {

    const rb = new RequestBuilder(this.rootUrl, EnvironmentConfigService.DeleteWordPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DeleteWordResp>;
      })
    );
  }

  /**
   * Delete word in dictionary
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteWord$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteWord(params: {
    body: DeleteWordReq
  }): Observable<DeleteWordResp> {

    return this.deleteWord$Response(params).pipe(
      map((r: StrictHttpResponse<DeleteWordResp>) => r.body as DeleteWordResp)
    );
  }

  /**
   * Path part for operation getWords
   */
  static readonly GetWordsPath = '/env/get-words';

  /**
   * Get all words from dictionary
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getWords()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getWords$Response(params: {
    body: GetWordsReq
  }): Observable<StrictHttpResponse<GetWordsResp>> {

    const rb = new RequestBuilder(this.rootUrl, EnvironmentConfigService.GetWordsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GetWordsResp>;
      })
    );
  }

  /**
   * Get all words from dictionary
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getWords$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getWords(params: {
    body: GetWordsReq
  }): Observable<GetWordsResp> {

    return this.getWords$Response(params).pipe(
      map((r: StrictHttpResponse<GetWordsResp>) => r.body as GetWordsResp)
    );
  }

}
